/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeviceInUseDto } from '../../models/device-in-use-dto';

export interface UpdateGroupDevices$Params {
  harvestId: number;
      body: Array<DeviceInUseDto>
}

export function updateGroupDevices(http: HttpClient, rootUrl: string, params: UpdateGroupDevices$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateGroupDevices.PATH, 'put');
  if (params) {
    rb.path('harvestId', params.harvestId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateGroupDevices.PATH = '/api/harvests/{harvestId}/group/devices';
